export const fundsOriginList = [
	{
		NAME: 'España',
		VALUE: 'ESPAÑA',
	},
	{
		NAME: 'Unión Europea',
		VALUE: 'UNION_EUROPEA',
	},
	{
		NAME: 'Otros',
		VALUE: 'OTHER',
	},
];

export const fundsOriginTypes = fundsOriginList.reduce((acc, item) => {
	acc[item.NAME] = item.VALUE;
	return acc;
}, {});
